import { Box, Text, Button } from '@chakra-ui/react';
import React from 'react';

const PreviewLicenses = ({ items }) => {

  return (
    <Box className="contentBox">
      {Object.values(items).map((item) => {
          return (
            <Text className="subSections">
              <Box className="subSectionsInterior">
                <Box className="subSection">
                  <Text className="name">{item.organization}</Text>
                </Box>
                <Box>
                  <Box className="alignRight">{item.month} {item.year}</Box>
                </Box>
              </Box>
              <Box>
                <Box>
                  <Text>{item.name}</Text>
                </Box>
              </Box>
            </Text>
          );
        },
      )}
    </Box>
  );
};
export default PreviewLicenses;
